import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vShow as _vShow, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 批量导入 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("导入")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新建收款")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新建付款")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("新建付款")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Add Payment")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!
  const _directive_active = _resolveDirective("active")!

  return (_openBlock(), _createBlock(_component_page_wrapper, { title: _ctx.title }, {
    default: _withCtx(() => [
      _createVNode(_component_we_table, { onRegister: _ctx.register }, {
        name: _withCtx(({ text, record }) => [
          _withDirectives(_createVNode(_component_a_button, {
            type: "link",
            onClick: ($event: any) => (_ctx.jumpToPay(record, true))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]), [
            [_directive_active]
          ])
        ]),
        rd_state_name: _withCtx(({ text, record }) => [
          _createElementVNode("span", {
            style: _normalizeStyle({ color: record.rd_state_color })
          }, _toDisplayString(text), 5)
        ]),
        rd_invoice_link_status: _withCtx(({ text }) => [
          _createElementVNode("span", {
            style: _normalizeStyle({ color: text === 'Done' ? 'rgb(76, 175, 80)' : 'rgb(245, 124, 0)' })
          }, _toDisplayString(text), 5)
        ]),
        headerButton: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _ctx.filterType,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterType) = $event)),
            options: _ctx.dateRangeOptions,
            onChange: _ctx.reload,
            style: {"width":"240px !important"}
          }, null, 8, ["value", "options", "onChange"]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.importNoContract
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.isDirectPage && _ctx.hasPermission('CanImportNoContractData')]
          ]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.batchImportPay
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.canAddReceipt]
          ]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.addDemandPay
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.canAddReceipt]
          ]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.addPayment
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.canAddPayment]
          ]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.addDirect
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_vShow, _ctx.canAddDirectPayment]
          ])
        ]),
        _: 1
      }, 8, ["onRegister"]),
      _createVNode(_component_a_modal, {
        visible: _ctx.addPaymentDialog,
        "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addPaymentDialog) = $event)),
        width: 1200,
        centered: "",
        zIndex: 999
      }, {
        default: _withCtx(() => [
          _createVNode(_component_we_table, _mergeProps({ ref: "addPaymentTable" }, _ctx.paymentBillListConfig, { dataSource: _ctx.addPaymentBillList }), {
            name: _withCtx(({ text, record }) => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (_ctx.jumpToBill({ id: record.id }))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(text), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            add_payment_action: _withCtx(({ record }) => [
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (_ctx.toAddBillPayment(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 16, ["dataSource"])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _: 1
  }, 8, ["title"]))
}